import BootstrapTooltip from "@/react/bootstrap/components/BootstrapTooltip";
import ContentErrors from "@/react/story/components/ContentErrors";
import useEditorStats from "@/react/story/hooks/useEditorStats";
import { useConfig } from "@/react/story/providers/ConfigContext";
import { useErrors } from "@/react/story/providers/ErrorsContext";
import { useItems } from "@/react/story/providers/ItemsContext";
import type { Route } from "@/react/story/types";
import { ReactSortable } from "react-sortablejs";

function formatDuration(ms: number | null): string {
    if (null === ms) {
        return "-";
    }

    const seconds = Math.round(ms / 1000);
    if (seconds < 60) {
        return `${seconds}s`;
    }

    const minutes = Math.floor(seconds / 60);
    const remaining = seconds % 60;

    return `${minutes}m${remaining}s`;
}

export default function NavPages() {
    const Config = useConfig();
    const Items = useItems();
    const Errors = useErrors();
    const EditorStats = useEditorStats();

    const renderRoute = (route: Route, i: number, isSortable: boolean) => {
        const pageStats = EditorStats[route.page.id] ?? null;

        return (
            <button
                key={route.id}
                type="button"
                className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center gap-1 ${route.id === Items.current?.id ? "active" : ""}`}
                onClick={() => Items.goto(route)}
            >
                <span className="me-auto"><span className="font-monospace">{1 + i}</span>/ {route.page.name}</span>
                <ContentErrors errors={Errors.inPage(route.page)} />
                {(route.page.from || route.page.to) ? (
                    route.page.isOnline ? (
                        <span className="bi-calendar-range text-success ms-3"></span>
                    ) : (
                        <span className="bi-calendar-range text-danger ms-3"></span>
                    )
                ) : null}
                {!Config.isOnline && null !== pageStats ? (
                    <BootstrapTooltip html title={`Vues : ${pageStats.views}<br>Temps moy. : ${formatDuration(pageStats.avgDuration)}<br>Clics liens : ${pageStats.linkClicks}`}>
            <span className="badge text-bg-secondary d-flex align-items-center gap-1">
              <span className="bi-eye"></span>
                {pageStats.views}
            </span>
                    </BootstrapTooltip>
                ) : null}
                {isSortable ? (
                    <span className="bi-grip-vertical cursor-grab ms-3"></span>
                ) : null}
            </button>
        );
    };

    const navs = Items.getNavs();

    return (
        <>
            <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                <h2 className="mb-0 me-auto">Pages</h2>
                <BootstrapTooltip title="Ajouter">
                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => Items.goto(null)}>
                        <span className="bi-plus"></span>
                    </button>
                </BootstrapTooltip>
            </div>
            {navs.length > 0 ? (
                <>
                    {/* @ts-expect-error react-sortablejs types incompatible with React 18 */}
                    <ReactSortable list={navs} setList={list => Items.sort(list)} className="list-group mb-3">
                        {navs.map((nav, i) => {
                            if (nav.story) {
                                return (
                                    <div key={i} className="list-group-item list-group-item-primary">
                                        <div className="d-flex mb-2">
                                            <div className="d-block me-auto"><span className="font-monospace">{1 + i}</span>/ {nav.story.name}</div>
                                            <span className="bi-grip-vertical cursor-grab ms-3"></span>
                                        </div>
                                        <div className="list-group list-group-flush">
                                            {nav.routes.map((r, index) => renderRoute(r, index, false))}
                                        </div>
                                    </div>
                                );
                            }

                            return nav.routes.map((r, index) => renderRoute(r, i + index, true));
                        })}
                    </ReactSortable>
                </>
            ) : (
                <p className="text-muted">Vous n'avez pas encore ajouté de page à votre story.</p>
            )}
            {Items.routes.length > 2 ? (
                <p className="text-muted small lh-sm">
                    Vous pouvez réordonner vos pages pour changer l'ordre dans
                    lequel elles apparaitront.
                </p>
            ) : null}
        </>
    );
}
